// @flow
import {Tag, isMarkdocAstTag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Checklist: MarkdocTagRegistration = {
  tag: 'checklist',
  component: 'Checklist',
  children: ['list'],
  attributes: {
    id: {type: String, required: false},
    title: {type: String, required: false},
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    const output = [];

    // Aggregate list items of all lists that are direct descendents of the `list` tag
    // so that list items that are wrapped with conditionals end up in the list.
    // This is necessary because block-level tags like `if` cause a list to terminate,
    // resulting in conditional list items ending up in a separate list
    for (const child of children) {
      if (
        isMarkdocAstTag(child) &&
        (child.name === this.tag || child.name === 'List')
      ) {
        output.push(...child.children);
      }
    }

    return new Tag(this.tag, attributes, output);
  },
};
